import i18n from 'src/i18n';

export let infoConstants = {
  //GE2CConstants: {
  getStarted: {
    pageHeading: i18n.t('getStartedPageHeading'),
    headingHelperText: i18n.t('getStartedheadingHelperText'),
    buttonText: i18n.t('interestedTxt'),
    cardListHeading: i18n.t('getStartedcardListHeading'),
  },

  // C2CConstants: {
  noAccess: {
    pageHeading: i18n.t('noAccesspageHeading'),
    headingHelperText: "",
    buttonText: i18n.t('interestedTxt'),
    cardListHeading: i18n.t('noAccesscardListHeading'),
  },

  expiredSub: {
    pageHeading: i18n.t('expiredSubpageHeading'),
    headingHelperText: i18n.t('expiredSubheadingHelperText'),
    buttonText: i18n.t('interestedTxt'),
    cardListHeading: i18n.t('expiredSubcardListHeading'),
  },
}

i18n.on('languageChanged', function () {
  updateTranslations();
});

function updateTranslations() {
  infoConstants = {
    //GE2CConstants: {
    getStarted: {
      pageHeading: i18n.t('getStartedPageHeading'),
      headingHelperText: i18n.t('getStartedheadingHelperText'),
      buttonText: i18n.t('interestedTxt'),
      cardListHeading: i18n.t('getStartedcardListHeading'),
    },
  
    // C2CConstants: {
    noAccess: {
      pageHeading: i18n.t('noAccesspageHeading'),
      headingHelperText: "",
      buttonText: i18n.t('interestedTxt'),
      cardListHeading: i18n.t('noAccesscardListHeading'),
    },
  
    expiredSub: {
      pageHeading: i18n.t('expiredSubpageHeading'),
      headingHelperText: i18n.t('expiredSubheadingHelperText'),
      buttonText: i18n.t('interestedTxt'),
      cardListHeading: i18n.t('expiredSubcardListHeading'),
    },
  }
}
